/** Angular and 3rd party dependencies */
import { Observable, Subscription } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, ViewRef, SimpleChanges, OnDestroy, OnChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';

/** In app dependencies */
import { Question } from 'src/app/model/question';
import { LifeStyleQuestion } from 'src/app/pages/medical-underwriting/model';
import { Tooltip } from 'src/app/model/tooltip';
import { MUConstants } from 'src/app/pages/medical-underwriting/medical-underwrting.constants';
import { PersonalDetails } from 'src/app/model/ngrx/personal-details.model';
import { AppState } from 'src/app/store/state/app.state';
import { UtilityServiceForMedicalService } from 'src/app/pages/medical-underwriting/services/utility-service';
import { AccordQuestionStoreModel } from 'src/app/pages/medical-underwriting/model/mcUserJourney.model';
import { DependantDetails } from 'src/app/model/ngrx/dependant-details.model';
import { UtilService, AnalyticsService } from 'src/app/shared';
import { formatDate } from '@angular/common';
import { SyncService } from 'src/app/pages/medical-underwriting/services/sync.service';
import { Router } from '@angular/router';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { AlertModal } from 'src/app/model/alert';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-date-dropdown',
  templateUrl: './date-dropdown.component.html',
  styleUrls: ['./date-dropdown.component.scss']
})
export class DateDropdownComponent implements OnInit, OnDestroy {

  @Input() question: LifeStyleQuestion;
  @Input() parent: UntypedFormGroup;
  @Input() parentForm: UntypedFormGroup;
  @Input() editMode: boolean;
  controlName: string;
  controlNameForMonth: string;
  controlNameForYear: string;
  @Input() indexToAppend: number;
  @Input() accordIndexToAppend: number;
  @Input() objToReferForAccord: AccordQuestionStoreModel;
  @Output() editModelHandler: EventEmitter<any> = new EventEmitter();
  @Output() onDisplayMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();
  public tooltipModalConfig: AlertModal;
  tooltipModal;
  displayTooltipAlert: boolean = false;

  domId: string;
  public selectedMonth: any;
  public selectedYear: any;
  public Years = [];
  public dateArray = [];

  public Months: any = [
    { key: 'January', value: '01' },
    { key: 'February', value: '02' },
    { key: 'March', value: '03' },
    { key: 'April', value: '04' },
    { key: 'May', value: '05' },
    { key: 'June', value: '06' },
    { key: 'July', value: '07' },
    { key: 'August', value: '08' },
    { key: 'September', value: '09' },
    { key: 'October', value: '10' },
    { key: 'November', value: '11' },
    { key: 'December', value: '12' }
  ];

  private startYear: string;
  private endYear: string;
  personalDetailsData: Observable<PersonalDetails[]>;
  dateOfBirth: string;
  dependantDetailsStore: Observable<DependantDetails[]>;
  loggedinDetailsStore: Observable<any[]>;
  storeSubscription: Subscription;
  subscription: Subscription;

  constructor(private fb: UntypedFormBuilder, private cdRef: ChangeDetectorRef,
    private store: Store<AppState>, private syncService: SyncService,
    private utilService: UtilService, private utilityServiceForMedicalService: UtilityServiceForMedicalService,
    private analyticsService: AnalyticsService, private router: Router,
    private activatedRoute: ActivatedRoute) {
      
      this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;

    this.subscription = this.utilService.emitDropdown.subscribe(val => {
      if (this.cdRef && !(this.cdRef as ViewRef).destroyed) {
        this.cdRef.detectChanges();
      }
    });

    if (this.utilityServiceForMedicalService.currentUWScreenName === 'annuitant') {

      this.loggedinDetailsStore = store.select(STORE_VAL.loggedin_detail);
      this.storeSubscription = this.loggedinDetailsStore.subscribe((val) => {
        if (val.length > 0) {
          this.dateOfBirth = val[0].customer.dateOfBirth.split('/').join(' / ');
        }
      });

      if (!this.dateOfBirth) {
        this.personalDetailsData = store.select(STORE_VAL.personal_details);
        // console.log('personalDetailsData 1', this.personalDetailsData);
        this.storeSubscription = this.personalDetailsData.subscribe((val) => {
          if (val.length > 0) {
            this.dateOfBirth = val[0].dateOfBirth;
          }
        });
      }

    }

    if (this.utilityServiceForMedicalService.currentUWScreenName === 'dependant') {
      this.dependantDetailsStore = store.select(STORE_VAL.dependant_details);
      this.storeSubscription = this.dependantDetailsStore.subscribe((val) => {
        if (val.length > 0) {
          this.dateOfBirth = val[0].dateOfBirth;
        }
      });
    }

  }
  ngOnInit() {
    this.domId = this.utilityServiceForMedicalService.getDomId(this.question.id, this.accordIndexToAppend, this.indexToAppend);
    this.controlName = this.utilityServiceForMedicalService.getControlName(this.question.id, this.accordIndexToAppend);
    let controlNameToSetForDropdown = this.utilityServiceForMedicalService.getControlNameWithAccordAndTabIndex(this.question.id, this.accordIndexToAppend, this.indexToAppend);
    this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    this.controlNameForMonth = controlNameToSetForDropdown + '-' + 'monthly';
    this.controlNameForYear = controlNameToSetForDropdown + '-' + 'yearly';
    let dateObj = new Date();
    let currentYear = dateObj.getFullYear();
    if (this.question.responseRange !== null && this.question.responseRange.includes('nextyear')) {
      for (let i = currentYear + 1; i >= 1900; i--) {
        this.Years.push(i.toString());
      }
    } else {
      for (let i = currentYear; i >= 1900; i--) {
        this.Years.push(i.toString());
      }
    }
    this.selectedYear = "";
    this.selectedMonth = "";
    if (this.objToReferForAccord) {
      this.question.responseValueByUser = this.utilityServiceForMedicalService.getResponseValueFromRefObj(this.objToReferForAccord, this.question.id, this.accordIndexToAppend);
    }
    if (this.question.responseValueByUser) {
      let temp = this.question.responseValueByUser.split(MUConstants.dateFromatDelimiterToAPI);
      let monthValue = temp[1];
      this.selectedYear = temp[0];
      if (temp[0 && temp[1]]) {
        this.selectedMonth = this.findMonthObj(monthValue);
      }

      this.setValueForDateMonthYearlInForm(this.question, this.formDateMonthYear());
    }
    // if (this.editMode) {
    //   this.subscription = this.utilService.updateEditForm.subscribe(res => {
    //     if (res) {
    //       this.editMode = false;
    //       this.onChangeOfDropdown(event);
    //     }
    //   });
    // }

    if (this.parent.controls[this.controlName]) {
      this.syncService.businessValidationEvent.subscribe((res) => {
        this.setValueForDateMonthYearlInForm(this.question, this.formDateMonthYear());
      });
    }
  }

  ngOnDestroy(): void {
    if (this.storeSubscription) {
      this.storeSubscription.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.selectedYear = "";
    this.selectedMonth = "";
  }

  formDateMonthYear(): string {
    let dateMonthAndYear: string;
    if (this.selectedMonth && this.selectedYear) {
      dateMonthAndYear = this.selectedYear + MUConstants.dateFromatDelimiterToAPI + this.selectedMonth;
    } else {
      dateMonthAndYear = null;
    }
    return dateMonthAndYear;
  }

  primaryBtnClickHandler() {
    // this.primaryBtnClick.emit(true);
  }

  initializeToolTipDateComp(questionObj: LifeStyleQuestion): Tooltip {
    return new Tooltip(questionObj.helpText, '', false);
  }

  findMonthObj(monthValue: string) {
    let monthObj;
    this.Months.forEach(element => {
      if (element.value === monthValue) {
        monthObj = element;
      }
    });
    return monthObj.value;
  }

  secondaryBtnClickHandler() {
    // this.secondaryBtnClick.emit(true);
  }

  close() {
    // this.closeModal.emit(true);
  }

  setValueForDateMonthYearlInForm(question: LifeStyleQuestion, dateMonthYear: string) {
    this.checkDateValidationsForDateQuestions(dateMonthYear, question);
    if(dateMonthYear === null){
      this.setErrorsRequired();
    }
    if (this.parent.controls[this.controlName]) {
      this.parent.controls[this.controlName].setValue(dateMonthYear);
    }
    else {
      this.parent.addControl(this.controlName, this.fb.control(null, question.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null));
      this.parent.controls[this.controlName].setValue(dateMonthYear);
    }
  }

  onChangeOfDropdown(event) {
    if (this.editMode) { // if (this.editMode && !onPageLoad) {
      const payload = {
        value: this.question
      };
      if (!this.subscription) {
        this.subscription = this.utilService.updateEditForm.subscribe(res => {
          if (res) {
            this.editMode = false;
            this.onChangeOfDropdown(event);
          }
        });
      }
      this.editModelHandler.emit(payload);
    } else {
      this.setValueForDateMonthYearlInForm(this.question, this.formDateMonthYear());
      this.markBothMonthAndYearAsTouched();
    }
  }
  isMonthAndYearBothSelected(): boolean {
    let monthAndYearBothAvailable: boolean = true;
    if ((this.parent.get(this.controlNameForMonth) && this.parent.get(this.controlNameForMonth).errors && this.parent.get(this.controlNameForMonth).errors.required)
      || (this.parent.get(this.controlNameForYear) && this.parent.get(this.controlNameForYear).errors && this.parent.get(this.controlNameForYear).errors.required)) {
      monthAndYearBothAvailable = false;
    }
    return monthAndYearBothAvailable;
  }

  markBothMonthAndYearAsTouched() {
    if (this.parent.get(this.controlNameForMonth) && this.parent.get(this.controlNameForYear)) {
      this.parent.get(this.controlNameForMonth).markAsTouched();
      this.parent.get(this.controlNameForYear).markAsTouched();
    }
  }

  setErrorsRequired(){
    let isMandatoryFlag = (this.question.mandatoryResponse.toLocaleUpperCase() === "YES") ? true: false;
    if (isMandatoryFlag && !this.selectedMonth && this.parent.get(this.controlNameForMonth)) {
      this.parent.get(this.controlNameForMonth).setErrors({required: true});
    }
    else if (isMandatoryFlag && !this.selectedYear && this.parent.get(this.controlNameForYear)) {
      this.parent.get(this.controlNameForYear).setErrors({required: true});
    } 
  }

  lifestyleInfoReceiver(value: LifeStyleQuestion) {
    if (value && this.utilityServiceForMedicalService.isPartOfWA(value.questionText)) {
      this.analyticsService.eventTrack({ type: 'Question', name: value.questionText, pageID: this.getCurrentScreenURL() });
    }
  }

  getCurrentScreenURL() {
    let screenName = this.utilService.getScreenNameFromURL(this.router.url);
    return screenName;
  }

  checkDateValidationsForDateQuestions(monthYear: string, question: LifeStyleQuestion) {
    if (this.checkStart_and_FutureDateValidation(monthYear, question)) {

    } else
      if (question.origoElement && question.origoElement && (question.origoElement.includes('start_date') ||
        question.origoElement.includes('diagnosed_date') || question.origoElement.includes('result_date')
        || question.origoElement.includes('surgery_date'))) {
        question.responseValueByUser = question.responseValueByUser ? question.responseValueByUser : null;
        if (monthYear) {
          let birthdate = +(this.dateOfBirth.split(' / ')[2]);
          let startDate = +(monthYear.split('-')[0]);
          if ((startDate < birthdate) || (startDate === birthdate)) {
            this.parent.get(this.controlNameForYear).setErrors({ startDateInvalid: true });
          } else {
            this.parent.get(this.controlNameForYear).setErrors(null);
            question.responseValueByUser = monthYear;
            let endDateQuestionObj = this.utilityServiceForMedicalService.getdateDropdownMatchingQuestionFromList(question, 'end_date');
            if (endDateQuestionObj && endDateQuestionObj.responseValueByUser && this.parentForm.controls[endDateQuestionObj.id]) {
              let endDate = endDateQuestionObj.responseValueByUser.split('-');
              let startdate = monthYear.split('-');
              let controlNameForYear = endDateQuestionObj.id + '-' + 'yearly';
              let controlNameForMonth = endDateQuestionObj.id + '-' + 'monthly';
              if (+(endDate[0]) < +(startdate[0])) {
                this.parentForm.controls[endDateQuestionObj.id].get(controlNameForYear).setErrors({ notValid: true });
              } else
                if (+(endDate[0]) === +(startdate[0]) && +(endDate[1]) < +(startdate[1])) {
                  this.parentForm.controls[endDateQuestionObj.id].get(controlNameForYear).setErrors(null);
                  this.parentForm.controls[endDateQuestionObj.id].get(controlNameForMonth).setErrors({ notValid: true });
                } else {
                  this.parentForm.controls[endDateQuestionObj.id].get(controlNameForYear).setErrors(null);
                  this.parentForm.controls[endDateQuestionObj.id].get(controlNameForMonth).setErrors(null);
                }
            }
          }
        }
        this.utilityServiceForMedicalService.setdateDropdownQuestionToList(question);
      } else if (question && question.origoElement && question.origoElement.includes('end_date')) {
        let startDateQuestionObj = this.utilityServiceForMedicalService.getdateDropdownMatchingQuestionFromList(question, 'start_date');
        if (monthYear && startDateQuestionObj) {
          question.responseValueByUser = monthYear;
          let endDate = monthYear.split('-');
          let startdate = startDateQuestionObj.responseValueByUser.split('-');
          if (+(endDate[0]) < +(startdate[0])) {
            this.parent.get(this.controlNameForYear).setErrors({ notValid: true });
          } else
            if (+(endDate[0]) === +(startdate[0]) && +(endDate[1]) < +(startdate[1])) {
              this.parent.get(this.controlNameForYear).setErrors(null);
              this.parent.get(this.controlNameForMonth).setErrors({ notValid: true });
            } else {
              this.parent.get(this.controlNameForYear).setErrors(null);
              this.parent.get(this.controlNameForMonth).setErrors(null);
            }
        }
        this.utilityServiceForMedicalService.setdateDropdownQuestionToList(question);
      }
  }

  checkStart_and_FutureDateValidation(monthYear, question): boolean {
    let notValid: boolean = false;
    if (monthYear) {
      let givenDate = monthYear.split("-");
      let tempDate = formatDate(new Date(), 'yyyy/MM/dd', 'en');
      let birthdate = +(this.dateOfBirth.split(' / ')[2]);
      let currentDate = tempDate.split("/");
      // if (question.responseRange !== null && question.responseRange.includes('nextyear')) {
      //   let temp = +(currentDate[0]) + 1;
      //   currentDate[0] = temp.toString();
      // }
      if (!(question.responseRange !== null && question.responseRange.includes('nextyear')) && +(givenDate[0]) > +(currentDate[0])) {
        this.parent.get(this.controlNameForYear).setErrors({ futureDateInvalid: true });
        notValid = true;
      } else if (!(question.responseRange !== null && question.responseRange.includes('nextyear')) && (+(givenDate[0]) === +(currentDate[0])) && (+(givenDate[1]) > +(currentDate[1]))) {
        this.parent.get(this.controlNameForMonth).setErrors({ futureDateInvalid: true });
        notValid = true;
      } else if (+(givenDate[0]) < birthdate) {
        this.parent.get(this.controlNameForYear).setErrors({ startDateInvalid: true });
      } else if (+(givenDate[0]) < +(currentDate[0])) {
        this.parent.get(this.controlNameForMonth).setErrors(null);
        this.parent.get(this.controlNameForYear).setErrors(null);
      }
    } else if (question && question.mandatoryResponse.toUpperCase() === 'NO' && this.parent.get(this.controlNameForYear) && this.parent.get(this.controlNameForMonth) && this.parent.get(this.controlNameForYear).value && (!this.parent.get(this.controlNameForMonth).value)) {
      this.parent.get(this.controlNameForYear).clearValidators();
      this.parent.get(this.controlNameForYear).updateValueAndValidity({ onlySelf: true });
      this.parent.get(this.controlNameForMonth).setValidators(Validators.required);
      this.parent.get(this.controlNameForMonth).updateValueAndValidity({ onlySelf: true });
      this.parent.get(this.controlNameForMonth).markAsUntouched({ onlySelf: true });
    } else if (question && question.mandatoryResponse.toUpperCase() === 'NO' && this.parent.get(this.controlNameForYear) && this.parent.get(this.controlNameForMonth) && this.parent.get(this.controlNameForMonth).value && !this.parent.get(this.controlNameForYear).value) {
      this.parent.get(this.controlNameForMonth).clearValidators();
      this.parent.get(this.controlNameForMonth).updateValueAndValidity({ onlySelf: true });
      this.parent.get(this.controlNameForYear).setValidators(Validators.required);
      this.parent.get(this.controlNameForYear).updateValueAndValidity({ onlySelf: true });
      this.parent.get(this.controlNameForYear).markAsUntouched({ onlySelf: true });
    } else if (question && question.mandatoryResponse.toUpperCase() === 'NO' && this.parent.get(this.controlNameForYear) && this.parent.get(this.controlNameForMonth) && !this.parent.get(this.controlNameForMonth).value && !this.parent.get(this.controlNameForYear).value) {
      this.parent.get(this.controlNameForMonth).clearValidators();
      this.parent.get(this.controlNameForMonth).updateValueAndValidity({ onlySelf: true });
      this.parent.get(this.controlNameForYear).clearValidators();
      this.parent.get(this.controlNameForYear).updateValueAndValidity({ onlySelf: true });
    }
    return notValid;
  }


  displayDrpTooltipMessage(question){
    this.tooltipModal.content = question.helpText;
    this.displayTooltipAlert = true;
  }

  alertTooltipPrimaryBtnClick() {
		this.closeModal();
	}

	closeModal() {
		this.displayTooltipAlert = false;
	}
}
